<template>
  <div class="login-container">
    <header>
      <a href="https://hmc.co.il/" target="_blank">
        <img class="logo" src="assets/img/svg/logo-blue.svg" alt="logo" />
      </a>
      <div v-if="!isApplication" class="header-actions">
        <a
          href="https://hmc.co.il/"
          target="_blank"
          class="lg:only-up head-back-desk flex items-center p-1 gap-2 text-lg border-b-2 border-aqua"
        >
          <img src="assets/img/svg/arrow-right-blue.svg" alt="back" /> חזרה לאתר
          הראשי
        </a>
      </div>
    </header>

    <div class="login-main-container">
      <div class="login-inner-container">
        <BiometricTerms
          v-if="showBiometricTerms"
          @toggleBiometricTerms="toggleBiometricTerms"
          @acceptTerms="isBiometricFlow = true"
        />

        <template v-else>
          <LoginForm
            @toggleBiometricTerms="toggleBiometricTerms"
            :isBiometricFlow="isBiometricFlow"
          />
          <Terms v-show="!isBiometricFlow" />
        </template>
      </div>

      <img
        class="login-background"
        src="assets/img/layout/login-background.png"
      />
    </div>
  </div>
</template>

<script>
import LoginForm from "../components/Login/Login.vue";
import EnterPop from "../components/Popups/EnterPop.vue";
import Terms from "../components/Shared/Terms.vue";
import BiometricTerms from "../components/Login/BiometricTerms.vue";
import { isApplication, isOutdatedApplication } from "../utilities/globals";

export default {
  name: "Login",
  components: { LoginForm, Terms, BiometricTerms },

  data: function() {
    return {
      loaded: false,
      titles: {
        1: "MyMedical Doctors",
        2: "MyMedical Doctors",
        3: "ברוכים הבאים"
      },
      showBiometricTerms: false,
      isBiometricFlow: false
    };
  },
  computed: {
    /**
     * Outdated application versions do not set the cookie isApplication
     * relies on, so they are matched separately — see globals.js. Both have
     * to count as the application here, otherwise the store popup below
     * comes up inside the application itself.
     */
    isApplication() {
      return isApplication() || isOutdatedApplication();
    }
  },
  mounted() {
    const isMobile = window.innerWidth < 1200;
    const initMobile = localStorage.getItem("init-mobile");
    const initDesktop = localStorage.getItem("init-desktop");
    if (isMobile && !initMobile && !this.isApplication) {
      localStorage.setItem("init-mobile", true);
      this.$modal.show(EnterPop, { step: "init-mobile" });
    } else if (!isMobile && !initDesktop && !this.isApplication) {
      localStorage.setItem("init-desktop", true);
      this.$modal.show(EnterPop, { step: "init-desktop" });
    }
    this.loaded = true;
  },
  methods: {
    toggleBiometricTerms() {
      this.showBiometricTerms = !this.showBiometricTerms;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
